import React, { useState, useEffect, useCallback } from 'react';

interface KeywordCounterProps {
    parsedPlainText: string | null;
    keyword: string;
    excludedKeywords: string[];
    mergeStatus: string;
    updateCount: (keyword: string, count: number) => void;
    isExcluded?: boolean;
}

const escapeRegExp = (string: string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

const KeywordCounter: React.FC<KeywordCounterProps> = ({
    parsedPlainText,
    keyword,
    excludedKeywords,
    updateCount,
    mergeStatus,
    isExcluded
}) => {
    const [keywordCount, setKeywordCount] = useState<number>(0);

    const countKeyword = useCallback((text: string, targetKeyword: string) => {
        const escapedKeyword = escapeRegExp(targetKeyword);
        const regex = new RegExp(escapedKeyword, 'gi');
        const count = (text.match(regex) || []).length;
        return count;
    }, []);

    const removeExcludedKeywords = useCallback((text: string, excludedKeywords: string[]) => {
        let modifiedText = text;
        excludedKeywords.forEach(excludedKeyword => {
            const escapedKeyword = escapeRegExp(excludedKeyword);
            const regex = new RegExp(escapedKeyword, 'gi');
            modifiedText = modifiedText.replace(regex, '');
        });
        return modifiedText;
    }, []);

    useEffect(() => {
        if (mergeStatus === 'idle') {
            setKeywordCount(0);
        } else if (parsedPlainText && mergeStatus === 'completed') {
            if (isExcluded) {
                const excludedCount = countKeyword(parsedPlainText, keyword);
                setKeywordCount(excludedCount);
                updateCount(keyword, excludedCount);
            } else {
                const modifiedText = removeExcludedKeywords(parsedPlainText, excludedKeywords);
                const totalKeywordCount = countKeyword(modifiedText, keyword);
                setKeywordCount(totalKeywordCount);
                updateCount(keyword, totalKeywordCount);
            }
        }
    }, [parsedPlainText, mergeStatus, keyword, excludedKeywords, updateCount, countKeyword, removeExcludedKeywords, isExcluded]);

    return (
        <span style={keywordCount >= 1 ? { color: 'red', fontWeight: 'bold' } : undefined}>
            {keywordCount}
        </span>
    );
};

export default KeywordCounter;
